(function() { module.exports = window["Next"]["Divider"]; }());